import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhPageHeaderComponent } from './components/fh-page-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { FhTextModule } from '@fh-client-interaction-frontends/fh-text';
import { FhButtonModule } from '@fh-client-interaction-frontends/fh-button';
import { TooltipModule } from 'primeng/tooltip';
import { FhStatusModule } from '@fh-client-interaction-frontends/fh-status';

@NgModule({
  imports: [CommonModule, TranslateModule, FhTextModule, FhButtonModule, TooltipModule, FhStatusModule],
  declarations: [FhPageHeaderComponent],
  exports: [FhPageHeaderComponent]
})
export class FhPageHeaderModule {}
